var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",attrs:{"role":"alert"}},[_c('icon',{attrs:{"icon":['fad', this.icon]}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }